import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { NEEDS, DURATIONS, PREFERENCES } from "@/lib/sessions";
import { store } from "@/lib/storage";
import { ChevronLeft } from "lucide-react";

export default function Personalize() {
  const nav = useNavigate();
  const initial = store.getPrefs();
  const [need, setNeed] = useState(initial.need || "pause");
  const [minutes, setMinutes] = useState(initial.minutes || 5);
  const [preference, setPreference] = useState(initial.preference || "combi");

  function next() {
    store.setPrefs({ ...initial, need, minutes, preference });
    nav("/suggestions");
  }

  return (
    <div className="animate-fade-in pt-6">
      <button data-testid="back-btn" onClick={() => nav(-1)} className="flex items-center gap-1 text-[color:var(--ivoire-muted)] text-sm mb-4">
        <ChevronLeft size={16} /> Retour
      </button>
      <h1 className="font-serif text-3xl text-[color:var(--ivoire)]">Que ressentez-vous ?</h1>
      <p className="text-sm text-[color:var(--ivoire-muted)] mt-2">Ces choix orientent réellement les séances proposées.</p>

      <section className="mt-8">
        <p className="font-mono text-[10px] tracking-widest uppercase text-[color:var(--sauge-light)] mb-3">Besoin</p>
        <div className="grid grid-cols-1 gap-2">
          {NEEDS.map((n) => (
            <button
              key={n.id}
              data-testid={`need-${n.id}`}
              onClick={() => setNeed(n.id)}
              className={`text-left rounded-xl border px-4 py-3 transition ${
                need === n.id
                  ? "border-[color:var(--sauge)] bg-[color:var(--sauge)]/15"
                  : "border-[color:var(--border)] bg-[#142235]/60"
              }`}
            >
              <div className="font-medium text-[color:var(--ivoire)]">{n.label}</div>
              <div className="text-xs text-[color:var(--ivoire-muted)]">{n.hint}</div>
            </button>
          ))}
        </div>
      </section>

      <section className="mt-8">
        <p className="font-mono text-[10px] tracking-widest uppercase text-[color:var(--sauge-light)] mb-3">Durée</p>
        <div className="flex gap-2 flex-wrap">
          {DURATIONS.map((d) => (
            <button
              key={d}
              data-testid={`duration-${d}`}
              onClick={() => setMinutes(d)}
              className={`px-5 py-3 rounded-xl border font-mono text-sm transition ${
                minutes === d
                  ? "bg-[color:var(--sauge)] text-[color:var(--bg-deep)] border-[color:var(--sauge)]"
                  : "border-[color:var(--border)] bg-[#142235]/60 text-[color:var(--ivoire)]"
              }`}
            >
              {d} min
            </button>
          ))}
        </div>
      </section>

      <section className="mt-8">
        <p className="font-mono text-[10px] tracking-widest uppercase text-[color:var(--sauge-light)] mb-3">Préférence</p>
        <div className="grid grid-cols-1 gap-2">
          {PREFERENCES.map((p) => (
            <button
              key={p.id}
              data-testid={`pref-${p.id}`}
              onClick={() => setPreference(p.id)}
              className={`text-left rounded-xl border px-4 py-3 transition ${
                preference === p.id
                  ? "border-[color:var(--sauge)] bg-[color:var(--sauge)]/15"
                  : "border-[color:var(--border)] bg-[#142235]/60"
              }`}
            >
              <div className="font-medium text-[color:var(--ivoire)]">{p.label}</div>
            </button>
          ))}
        </div>
      </section>

      <button
        data-testid="see-suggestions-btn"
        onClick={next}
        className="mt-10 w-full h-14 rounded-2xl bg-[color:var(--sauge)] text-[color:var(--bg-deep)] font-medium text-base hover:bg-[color:var(--sauge-light)] transition"
      >
        Voir les suggestions
      </button>
    </div>
  );
}
